/* global SERVER_URL, VERSION, newrelic */
import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom/client';
import fetch from 'isomorphic-fetch';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import BrowserStore from 'store2';
import Hotjar from '@hotjar/browser';
import 'smartbanner.js/dist/smartbanner.min';
import 'smartbanner.js/dist/smartbanner.min.css';
import Root from './containers/Root/Root';
import configureStore from './store/configureStore';
import { authLoginUserSuccess, authLogout, authLogoutAndRedirect } from './actions/auth';
import { fetchUserFavoritesSuccess } from './actions/favorites';
import { checkHttpStatus, parseJSON } from './utils';
import { setUserPreferences } from './actions/uiPreferences';
import ExploreAuth from './utils/ExploreAuth';
import { initializeGA } from './utils/googleAnalytics';
import { initializeGTM } from './utils/googleTagManager';

document.addEventListener('smartbanner.view', function () {
  document.body.classList.add('smartbanner-on');
});

document.addEventListener('smartbanner.exit', function () {
  document.body.classList.remove('smartbanner-on');
});

const siteId = 5302753;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

// IE CustomEvent Polyfill
(() => {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
  return true;
})();

if (navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
  $('body').on('mousewheel', () => {
    const wd = event.wheelDelta;
    const csp = window.pageYOffset;
    event.preventDefault();
    window.scrollTo(0, csp - wd);
  });
}


const initialState = {};

const store = configureStore(initialState, browserHistory);
const history = syncHistoryWithStore(browserHistory, store);

let user = {};
let favorites = {};
try {
  if (BrowserStore.session.get('user')) {
    user = BrowserStore.session.get('user');
    if (BrowserStore.session.get('favorites')) {
      favorites = BrowserStore.session.get('favorites');
    }
  }
} catch (e) {
  console.error(e);
}

// Initialize Analytics
initializeGA();
initializeGTM();

if (Object.keys(user).length && user.user_id) {
  store.dispatch(authLoginUserSuccess(user));
  store.dispatch(setUserPreferences(_.get(user, 'preferences', {})));
  if (Object.keys(favorites).length) {
    store.dispatch(fetchUserFavoritesSuccess(favorites));
  }
}

const token = BrowserStore.get('token');
if (token) {
  ExploreAuth.getValidJwt()
    .then((tokenIsValid) => {
      // Token can't be refreshed log them out
      if (!tokenIsValid) {
        // We should probably add a modal here informing them they need to log back in.
        return authLogoutAndRedirect();
      }

      return fetch(`${SERVER_URL}/auth/get_authenticated_user_info`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'x-www-form-urlencoded',
          Authorization: `Bearer ${ExploreAuth.getJwt()}`,
        },
      })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((response) => {
          store.dispatch(authLoginUserSuccess(response.data));
          store.dispatch(setUserPreferences(response.data.preferences));
          store.dispatch(fetchUserFavoritesSuccess(response.data.favorites));
        })
        .catch((error) => {
          // There is a session but no logged in user. Clear data by logging out.
          console.log('user is not logged in');
          console.error(error);
          store.dispatch(authLogout());
        });
    });
}

// RegEx redirects
const redirectPatterns = {
  '^/videos.*$': '/films',
  '^/photography/?$': '/livecams',
};

Object.keys(redirectPatterns).forEach((pattern) => {
  const re = new RegExp(pattern);
  if (re.test(window.location.pathname)) {
    window.location = redirectPatterns[pattern];
  }
});

fetch(
  `${SERVER_URL}/redirects`,
).then(parseJSON)
.then((redirects) => {
  // Don't wait for the Router since some of these old routes may not be defined.
  // Also because we don't want to wait for initial state.
  if (redirects[window.location.pathname]) {
    window.location = redirects[window.location.pathname].uri;
  }
}).catch(e => console.error(e));
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root store={store} history={history} />);
